import React from 'react'
import PropTypes from 'prop-types'
import {find, reduce} from '@republic/foundation/lang/array'
import {get} from '@republic/foundation/lang/object'
import {createComponent} from '@republic/react-foundation'
import Particle from '../Particle'
import Quantum from '../Quantum'
import {config} from '../utils'

const
    settings = config('Container'),
    breakpoints = config('Breakpoints'),

    toValue = (value, unit) => (
        unit === 'rem' || unit === 'em' ?
            `${value / 16}${unit}` :
            `${value}${unit}`),

    makeLeaps = (cap, units) => {
        const capSize = get(find(breakpoints, ([, name]) => name === cap), 0)

        return (
            reduce(
                breakpoints,
                (leaps, [width]) => {
                    if (!capSize || width <= capSize) {
                        leaps.push([
                            width,
                            {width: toValue(width, units)}
                        ])
                    }
                    return leaps
                },
                [{width: '100%'}]))
    }

export default (
    createComponent(
        'Container',
        {
            propTypes: {
                units: PropTypes.oneOf(['rem', 'em', 'px', '%']),
                cap: PropTypes.string
            },
            defaultProps: {
                units: 'em',
                cap: settings.cap
            }
        },
        ({units, cap, ...props}) => (
            <Quantum leaps={makeLeaps(cap, units)}>
                {({width}) => (
                    <Particle
                        {...props}
                        maxWidth={width}
                        width={props.width || '100%'}
                        className={'bits-container'}
                        margin={
                            Object.assign(
                                {left: 'auto', right: 'auto'},
                                props.margin || {})
                        } />
                )}
            </Quantum>
        )))
